function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M24,48A24.006,24.006,0,0,1,14.658,1.886,24.006,24.006,0,0,1,33.342,46.114,23.849,23.849,0,0,1,24,48Zm8.971-28.521V33.23h1.5a1.489,1.489,0,0,0,1.5-1.476V16.826a1.478,1.478,0,0,0-.257-1.184,1.511,1.511,0,0,0-1.222-.632,1.458,1.458,0,0,0-.875.29l-9.629,7.039-9.564-6.953a1.552,1.552,0,0,0-2.139.32,1.394,1.394,0,0,0-.267.677,1.408,1.408,0,0,0-.011.179v15.17a1.482,1.482,0,0,0,1.5,1.5H15V19.511l8.966,6.508L32.97,19.48Z",
  fill: "#fff"
});

function SvgGmailWhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGmailWhite);
export default __webpack_public_path__ + "static/media/Gmail_white.94390e0a.svg";
export { ForwardRef as ReactComponent };